// obj of keys and values for walkme api keys
const getWalkMeCDNScript = (userId, isProductionEnv) => {
    const walkmeCDNs = {
        production: `https://cdn.walkme.com/users/${userId}/walkme_${userId}_https.js`,
        development: `https://cdn.walkme.com/users/${userId}/test/walkme_${userId}_https.js`,
    };

    return isProductionEnv ? walkmeCDNs.production : walkmeCDNs.development;
};

export default getWalkMeCDNScript;
